import { priceFormatedObject, validatePrice } from '@/utils/category';

export const calcCartTotalHandler = (items = []) => {
  console.log('items ----------- ', items)
  return items?.reduce((cur, acc) => {
    const price = validatePrice(priceFormatedObject(acc));
    return (
      cur + ((acc?.prices_with_tax?.final_price || acc?.price_incl_tax || price?.originalPrice) * acc?.qty || 0)
    );
  }, 0);
};
